<template>
	<div>
		<header id="header">
		<div class="wrap">
			<router-link class="logo float-left" :to="{ name: 'Index' }">
				<img src="@/assets/images/logo.svg" alt="高典國際開發有限公司LOGO" />
			</router-link>
			<ul class="nav float-right" style="margin-right: 90px">
			<!-- <li v-if="login_question_mark != null">
					<a  href="javascript:void(0)" @click="login_out">
					<i class="icon">
						<img src="@/assets/images/login/icon_logout.svg" alt="登出">
					</i>
					<p>登出</p>
					</a>
				</li>
				<li v-else>
					<router-link :to="{ name: 'Login' }">
						<i class="icon">
							<img src="@/assets/images/login/icon_login.svg" alt="登入">
						</i>
						<p>登入</p>
					</router-link>
				</li>
				<li v-show="login_question_mark != null">
					<router-link :to="{ name: 'MemberHome' }">
						<i class="icon">
							<img src="@/assets/images/login/icon_memberhome.svg" alt="租戶首頁">
						</i>
						<p>租戶首頁</p>
					</router-link>
				</li> -->
				<li v-if="$store.state.house_number != null">
					<a href="javascript:void(0)" @click="login_out">
						<i class="icon">
							<img src="@/assets/images/login/icon_logout.svg" alt="登出" />
						</i>
						<p>登出</p>
					</a>
				</li>
				<li v-else>
					<router-link :to="{ name: 'Login' }">
						<i class="icon">
							<img src="@/assets/images/login/icon_login.svg" alt="登入" />
						</i>
						<p>登入</p>
					</router-link>
				</li>
				<li v-show="$store.state.house_number != null">
					<router-link :to="{ name: 'MemberHome' }">
						<i class="icon">
							<img src="@/assets/images/login/icon_memberhome.svg" alt="租戶首頁" />
						</i>
						<p>租戶首頁</p>
					</router-link>
				</li>
				<li>
					<a :href="customer_service.line_service_url" target="_blank">
						<i class="icon">
							<img src="@/assets/images/icon_service.svg" alt="客服" />
						</i>
						<p>Line客服</p>
					</a>
				</li>
				<li>
					<a :href="customer_service.google_map_url" target="_blank">
						<i class="icon">
							<img src="@/assets/images/icon_map.svg" alt="導航" />
						</i>
						<p>導航</p>
					</a>
				</li>
			<!-- <li>
					<a :href="customer_service.facebook_url" target="_blank">
						<i class="icon">
							<img src="@/assets/images/icon_share.svg" alt="社群" />
						</i>
						<p>FB社群</p>
					</a>
				</li> -->
			</ul>
		</div>
		</header>
		<nav id="menu">
			<ul class="menu-list">
				<li>
					<a href="javascript:void(0);" class="btn-menu btnHam">
						詳細介紹
						<i><span></span><span></span><span></span></i>
					</a>
				</li>
				<li>
				<router-link :to="{ name: 'room', params: { id: parseInt(room_type_id) } }" class="btn-quick">
					快速<br />看房
					<i class="icon">
						<img src="@/assets/images/icon_quick.svg" alt="快速看房" />
					</i>
				</router-link>
				</li>
			</ul>
			<ul class="menu-nav">
				<li>
					<router-link :to="{ name: 'news' }"> 最新消息 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'about' }"> 高典大樓 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'room', params: { id: parseInt(room_type_id) } }">
						房型介紹
					</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'equipment' }"> 公共設施 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'location' }"> 周遭環境 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'notice' }"> 承租須知 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'sign' }"> 租約審閱 </router-link>
				</li>
				<li>
					<router-link :to="{ name: 'connection' }"> 聯絡我們 </router-link>
				</li>
			</ul>
		</nav>
		<!-- -------- -->
		<div id="container">
		<router-view>
			<!-- container -->
		</router-view>
		</div>
		<!-- -------- -->
		<footer>
			<a href="#" class="btn-top btnTop">
				<img src="@/assets/images/btn_top.svg" alt="Go Top"/>
			</a>
			<div id="footer">
				<p>
					<b>高典物業管理顧問有限公司</b>
				</p>
				<ul>
					<li>
						{{ customer_service.service_address }}
					</li>
				<li>
					<i>T</i>
					<a :href="'tel:' + customer_service.service_phone">
						{{ customer_service.service_phone }}
					</a>
				</li>
				<!-- <li><i>F</i>04-22347890</li> -->
				<li>
					<i>M</i>
						<a :href="customer_service.service_mail">
						{{ customer_service.service_mail }}
					</a>
				</li>
				</ul>
				<p>All Rights Reserved. Design by 超媒體管家</p>
			</div>
		</footer>
		<ul class="bottom-menu">
			<li>
				<router-link :to="{ name: 'MemberHome' }" class="btn-quick" v-if="$store.state.house_number != null">
					<i class="icon">
						<img src="@/assets/images/login/icon_memberhome.svg" alt="租戶首頁" />
					</i>
					<p>租戶首頁</p>
				</router-link>
				<router-link :to="{ name: 'room', params: { id: parseInt(room_type_id) } }" class="btn-quick" v-else>
					<i class="icon">
						<img src="@/assets/images/icon_quick.svg" alt="快速看房" />
					</i>
					<p>快速看房</p>
				</router-link>
			</li>
			<li>
				<a href="javascript:void(0)" @click="login_out" class="btn-quick" v-if="$store.state.house_number != null">
					<i class="icon">
						<img src="@/assets/images/login/icon_logout.svg" alt="登出" />
					</i>
					<p>登出</p>
				</a>
				<router-link :to="{ name: 'Login' }" class="btn-quick" v-else>
					<i class="icon">
						<img src="@/assets/images/login/icon_login.svg" alt="登入" />
					</i>
					<p>登入</p>
				</router-link>
			</li>
			<li>
				<a :href="customer_service.line_service_url" target="_blank">
					<i class="icon">
						<img src="@/assets/images/icon_service.svg" alt="客服" />
					</i>
					<p>Line客服</p>
				</a>
			</li>
			<li>
				<a :href="customer_service.google_map_url" target="_blank">
					<i class="icon">
						<img src="@/assets/images/icon_map.svg" alt="導航" />
					</i>
					<p>導航</p>
				</a>
			</li>
		<!-- <li>
			<a :href="customer_service.facebook_url" target="_blank">
			<i class="icon">
				<img src="@/assets/images/icon_share.svg" alt="社群" />
			</i>
			<p>FB社群</p>
			</a>
		</li> -->
		</ul>
	</div>
</template>

<script>
//css
import "@/assets/css/jquery-ui.css";
import "@/assets/css/slick.css";
import "@/assets/css/magnific-popup.css";
import "@/assets/css/style.css";
//js
import "jquery-ui-dist/jquery-ui";
// import '@/assets/js/datepicker-zh-TW.js'
import "@/assets/js/slick.min.js";
import "magnific-popup";
import "@/assets/js/script.js";
// --

export default {
	data() {
		return {
			customer_service: [],
			room_type_id: "",
			login_question_mark: localStorage.getItem("house_number"),
		};
	},
	components: {},
	filters: {
		// changePhone(value) {
		//     var len = value.length;
		//     var x = value.substring(2, len - 8);
		//     var values = value.replace(x, "-");
		//     return values;
		// }
	},
	beforeMount: function () {
		const formData = new FormData();
		formData.append("CMD", "TempletIndexList");
		this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
		.then((response) => {
			// console.log(response);
			if (response.data.result == false) {
				console.log(response.data.error_this);
			} else {
				const get_service = response.data.service;
				this.customer_service = get_service;
				const get_roomtypes = response.data.roomtypes;
				this.room_type_id = get_roomtypes.id;
			}
		})
		.catch((error) => {
			console.log(error);
		});
	},
	methods: {
		login_out() {
		var login_out = confirm("確定登出嗎?");
			if (login_out) {
				// this.$cookies.remove('house_number');
				localStorage.removeItem("house_number");
				localStorage.removeItem("DiagnosticTest");
				this.$store.state.house_number = null;
				this.$router.push({ name: "Index" });
			}
		},
	},
  mounted: function () {
    $(".btnHam").on("click", function (e) {
		e.preventDefault();
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(".menu-nav").removeClass("active");
		} else {
			$(this).addClass("active");
			$(".menu-nav").addClass("active");
		}
    });
    $(".menu-nav li").on("click", function () {
		if ($(".menu-nav").hasClass("active")) {
			$(".btnHam").removeClass("active");
			$(".menu-nav").removeClass("active");
		}
	});
    // $('半透明DIV').on('click', function () {
	// 	if ($(".menu-nav").hasClass("active")) {
	// 		$(".btnHam").removeClass("active");
	// 		$(".menu-nav").removeClass("active");
	// 	}
    // })
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
#header .wrap .logo {
  height: unset;
}
#header .wrap .logo img {
  height: 100px;
}
#header .wrap .nav {
  margin-top: 10px;
}
#menu {
  top: 138px;
}
#container {
  padding-top: 140px;
}
@media screen and (max-width: 1490px) {
  #menu {
    top: 0px;
  }
  #menu .menu-list li a {
    padding: 18px 20px;
  }
  #menu .menu-list li a.btn-menu i {
    margin-top: 8px;
  }
  #menu .menu-list li a.btn-menu {
    font-size: 16px;
  }
  #container {
    padding-top: 110px;
  }
}
</style>
